/** @format */

import { Component, OnInit, AfterViewInit, Inject, Output, EventEmitter, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DbService } from '../core/services/db.service';
import { AuthService } from '../core/services/auth.service';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlarmModalComponent } from '../pages/alarm-modal/alarm-modal.component';
import { AlertService } from '../core/services/alert.service';
import { Observable, lastValueFrom, map, take, tap } from 'rxjs';
import { Notification } from '../core/models/notification.model';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  @ViewChild('notificationDropdown', { static: false }) notificationDropdown: NgbDropdown;

  configData;
  openSwitch = false;
  // 알림
  unReadAlarmCount$: Observable<number>;
  notifications$: Observable<Notification[]>;

  //TODO 사이드 메뉴 리스트 넣기
  menu = [
    {
      label: '대시보드',
      icon: 'bx-home',
      link: '/dashboard',
    },

    {
      label: '회원 관리',
      icon: 'bx-user',
      subItems: [
        {
          label: '회원 리스트',
          link: '/user-list',
        },
        {
          label: '회원정보 변경 리스트',
          link: '/member-list',
        },
      ],
    },

    {
      label: '배송지역 관리',
      icon: 'bx bxs-truck',
      subItems: [
        {
          label: '배송지역 리스트',
          link: '/delivery-area-list',
        },
        {
          label: '배송지별 업체 리스트',
          link: '/delivery-member-list',
        },
      ],
    },

    {
      label: '시식신청 관리',
      icon: 'mdi mdi-food-apple-outline',
      subItems: [
        {
          label: '시식신청 리스트',
          link: '/order-tasting-list',
        },
        {
          label: '시식신청 안내 관리',
          link: '/order-tasting-notice',
        },
      ],
    },

    {
      label: '샐러드 관리',
      icon: 'mdi mdi-food',
      subItems: [
        {
          label: '샐러드 리스트',
          link: '/salad-list',
        },
        {
          label: '요일별 샐러드 관리',
          link: '/daily-salad-list',
        },
      ],
    },

    {
      label: '식단표 관리',
      icon: 'bx bx-food-menu',
      subItems: [
        {
          label: '식단표 리스트',
          link: '/info-menu-list',
        },
      ],
    },

    {
      label: '주문 관리',
      icon: 'bx bx-list-check',
      subItems: [
        {
          label: '오늘 주문 관리',
          link: '/today-order-list',
        },
        {
          label: '주문 내역 리스트',
          link: '/order-list',
        },
        {
          label: '주문 alert 관리',
          link: '/order-alert',
        },
        {
          label: '주문 안내 관리',
          link: '/order-notice',
        },
        {
          label: '고정 주문 안내 관리',
          link: '/regular-order-notice',
        },
        {
          label: '원산지 표시 관리',
          link: '/order-origin',
        },
        {
          label: '주문시간 관리',
          link: '/order-time',
        },
      ],
    },

    {
      label: '정산 관리',
      icon: 'bx-credit-card',
      subItems: [
        {
          label: '정산 내역 관리',
          link: '/calculation-list',
        },
      ],
    },

    {
      label: '서비스/정보 관리',
      icon: 'bx bx-cube',
      subItems: [
        {
          label: '우리푸드 소개 관리',
          link: '/woori-introduction',
        },
        {
          label: '연락처 관리',
          link: '/contact',
        },
        {
          label: '자주묻는질문 관리',
          link: '/faq-list',
        },
        {
          label: '공지사항 관리',
          link: '/notice-list',
        },
        {
          label: '1:1 문의 관리',
          link: '/inquiry-list',
        },
        {
          label: '배너 관리',
          link: '/banner-list',
        },
        {
          label: '팝업관리',
          link: '/popup-list',
        },
        {
          label: '약관 관리',
          link: '/terms',
        },
        {
          label: '회사 정보 관리',
          link: '/company-info',
        },
      ],
    },
  ];

  routerUrl: string;

  constructor(
    // private eventService: EventService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private db: DbService,
    private auth: AuthService,
    private modalService: NgbModal,
    private alertService: AlertService
  ) {
    router.events.forEach(event => {
      if (event instanceof NavigationEnd) {
        // this._activateMenuDropdown();
        this.routerUrl = event.url;
      }
    });
  }

  ngOnInit() {
    //사이드바 정의
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };
    this.readMyUnreadNotifications();
    this.readMyNotifications();
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  // 나의 알림 불러오기
  async readMyNotifications() {
    const uuid = await this.auth.checkLoggedIn();
    this.notifications$ = this.db.collection$('notifications', ref =>
      ref.where('uuid', '==', 'jMpUtSQdwTQ11sQvPWewZzdc3OC2').orderBy('dateCreated', 'desc')
    );
  }

  // 나의 알림중에서 안읽은 알림 불러오기
  async readMyUnreadNotifications() {
    const uuid = await this.auth.checkLoggedIn();

    this.unReadAlarmCount$ = this.db
      .collection$('notifications', ref => ref.where('uuid', '==', 'jMpUtSQdwTQ11sQvPWewZzdc3OC2').where('readSwitch', '==', false))
      .pipe(
        tap(console.log),
        map(notifications => notifications?.length)
      );
  }

  // 알림 상세 이동
  async goDetail(id: Notification['id'], url: Notification['url']) {
    this.router.navigate([url]);
    await this.db.updateAt(`notifications/${id}`, { readSwitch: true });
    this.notificationDropdown.close();
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    this.alertService.successConfirm('로그아웃을 진행하시겠습니까?').then(ok => {
      if (ok) {
        this.auth.logoutUser().then(() => {
          this.router.navigate(['/account/login']);
          this.alertService.swalToast('로그아웃 했어요.');
        });
      }
    });
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>('.active');
    if (activeTag) {
      activeTag.classList.remove('active');
    }
    if (list.openSwitch) {
      console.log('close');
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach(ele => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(`.atag${mi}${index}`);
            aTag.classList.add('active');
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add('active');
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }

  // 날짜 형식 지정
  setDateCreated(date) {
    const now = dayjs().format('YYYYMMDD');
    const alarmDate = dayjs(date).format('YYYYMMDD');
    if (now === alarmDate) {
      return dayjs(date).format('a hh:mm');
    } else {
      return dayjs(date).format('YY.MM.DD');
    }
  }

  //클릭시 active class
  // _activateMenuDropdown() {
  //   this._removeAllClass('mm-active');
  //   this._removeAllClass('mm-show');
  //   const links = document.getElementsByClassName('side-nav-link-ref');
  //   let menuItemEl = null;
  //   // tslint:disable-next-line: prefer-for-of
  //   const paths = [];
  //   for (let i = 0; i < links.length; i++) {
  //     paths.push(links[i]['pathname']);
  //   }
  //   var itemIndex = paths.indexOf(window.location.pathname);
  //   if (itemIndex === -1) {
  //     const strIndex = window.location.pathname.lastIndexOf('/');
  //     const item = window.location.pathname.substr(0, strIndex).toString();
  //     menuItemEl = links[paths.indexOf(item)];
  //   } else {
  //     menuItemEl = links[itemIndex];
  //   }
  //   if (menuItemEl) {
  //     menuItemEl.classList.add('active');
  //     const parentEl = menuItemEl.parentElement;
  //     if (parentEl) {
  //       parentEl.classList.add('mm-active');
  //       const parent2El = parentEl.parentElement.closest('ul');
  //       if (parent2El && parent2El.id !== 'side-menu') {
  //         parent2El.classList.add('mm-show');
  //         const parent3El = parent2El.parentElement;
  //         if (parent3El && parent3El.id !== 'side-menu') {
  //           parent3El.classList.add('mm-active');
  //           const childAnchor = parent3El.querySelector('.has-arrow');
  //           const childDropdown = parent3El.querySelector('.has-dropdown');
  //           if (childAnchor) {
  //             childAnchor.classList.add('mm-active');
  //           }
  //           if (childDropdown) {
  //             childDropdown.classList.add('mm-active');
  //           }
  //           const parent4El = parent3El.parentElement;
  //           if (parent4El && parent4El.id !== 'side-menu') {
  //             parent4El.classList.add('mm-show');
  //             const parent5El = parent4El.parentElement;
  //             if (parent5El && parent5El.id !== 'side-menu') {
  //               parent5El.classList.add('mm-active');
  //               const childanchor = parent5El.querySelector('.is-parent');
  //               if (childanchor && parent5El.id !== 'side-menu') {
  //                 childanchor.classList.add('mm-active');
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  // // 메뉴 클릭시 다른주소 remove class
  // _removeAllClass(className) {
  //   const els = document.getElementsByClassName(className);
  //   while (els[0]) {
  //     els[0].classList.remove(className);
  //   }
  // }

  async alarmModal() {
    const modalRef = this.modalService.open(AlarmModalComponent, {
      scrollable: false,
      centered: true,
      size: 'm',
      backdrop: 'static',
    });
  }

  // 읽음 처리
  async updateReadSwitch() {
    const unReadNotifications = await lastValueFrom(
      this.notifications$.pipe(
        map((data: Notification[]) => data.filter(v => !v.readSwitch)),
        take(1)
      )
    );
    await Promise.all(
      unReadNotifications.map(notification => {
        this.db.updateAt(`notifications/${notification.id}`, {
          readSwitch: true,
        });
      })
    );
  }

  // 알림 전체 삭제
  deleteAllAlarms() {
    this.alertService.successConfirm('알림을 삭제하시겠습니까?').then(async ok => {
      if (ok) {
        const notifications = await lastValueFrom(this.notifications$.pipe(take(1)));
        await Promise.all(
          notifications.map(async notification => {
            await this.db.delete(`notifications/${notification.id}`);
            this.alertService.swalToast('알림을 삭제했습니다.');
          })
        );
      }
    });
  }
}
